import { render, staticRenderFns } from "./SkuStatusHistory.vue?vue&type=template&id=b3a1db42&scoped=true&"
import script from "./SkuStatusHistory.vue?vue&type=script&lang=js&"
export * from "./SkuStatusHistory.vue?vue&type=script&lang=js&"
import style0 from "./SkuStatusHistory.vue?vue&type=style&index=0&id=b3a1db42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a1db42",
  null
  
)

export default component.exports